<template>
  <div class="viewsRatingStars">
    <span
      v-for="star in stars"
      :key="star"
      class="star"
      :style="getStarStyle(star)"
    >★</span>
    <span class="viewsRatingStars__rating">{{ rating > 0 ? rating.toFixed(1) : '-' }}</span>
  </div>
</template>

<script>
export default {
    props: {
        rating: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            stars: [1, 2, 3, 4, 5]
        };
    },
    methods: {
        getStarStyle(star) {
            const percentage = Math.max(0, Math.min(100, (this.rating - (star - 1)) * 100));
            return {
                background:
                    `linear-gradient(90deg, #FFCC01 ${percentage}%, #CBCBCB ${percentage}%)`,
                    '-webkit-background-clip': 'text',
            };
        }
    }
};
</script>
